import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useOrganization } from '@clerk/clerk-react';

// Hook implementation
export const useNavigateWithinOrg = () => {
    const navigate = useNavigate();
    const { organization } = useOrganization();

    return useCallback(
        (path: string) => {
            if (!organization?.slug) {
                console.warn('No organization found.');
                navigate('/orgs');
                return;
            }

            const normalizedPath = path.startsWith('/') ? path : `/${path}`;
            navigate(`/orgs/${organization.slug}${normalizedPath}`);
        },
        [navigate, organization?.slug],
    );
};

export const useNavigateWithinProject = () => {
    const navigate = useNavigate();
    const { organization } = useOrganization();
    const { projectId } = useParams<{ projectId: string }>();

    return useCallback(
        (path: string) => {
            if (!organization?.slug) {
                console.warn('No organization found.');
                navigate('/orgs');
                return;
            }
            if (!projectId) {
                console.warn('No project found.');
                navigate(`/orgs/${organization.slug}/projects`);
                return;
            }

            const normalizedPath = path.startsWith('/') ? path : `/${path}`;
            navigate(
                `/orgs/${organization.slug}/projects/${projectId}${normalizedPath}`,
            );
        },
        [navigate, organization?.slug],
    );
};

interface NavigateWithinProps {
    to: string;
}

export const NavigateWithinOrg: React.FC<NavigateWithinProps> = ({ to }) => {
    const navigateWithinOrg = useNavigateWithinOrg();

    useEffect(() => {
        navigateWithinOrg(to);
    }, [navigateWithinOrg, to]);

    return null;
};

export const NavigateWithinProject: React.FC<NavigateWithinProps> = ({
    to,
}) => {
    const navigateWithinProject = useNavigateWithinProject();

    useEffect(() => {
        navigateWithinProject(to);
    }, [navigateWithinProject, to]);

    return null;
};
